import script from "./ManageExamsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageExamsView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageExamsView.vue?vue&type=style&index=0&id=0c421d6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c421d6a"]])

export default __exports__